import Image from 'next/image';
import Link from 'next/link';

import { routes } from '../constants/routes';

const currentYear = new Date().getFullYear();

export default function DisabledFeaturePage() {
  return (
    <div className="flex min-h-screen flex-col">
      <div className="mt-auto flex flex-1 items-center justify-center">
        <div className="flex flex-col items-center">
          <div className="mb-16 flex">
            <Image
              alt="logo"
              height={83}
              src="/images/logo-with-text.svg"
              width={238}
            />
          </div>
          <Image
            alt="lesson-planner-maintenance"
            height={250}
            src="/images/maintenance.svg"
            width={367}
          />

          <div className="mt-5 mb-5 text-center text-4xl font-bold text-[#212121] sm:text-[44px]">
            Feature Under Maintenance!
          </div>
          <div className="p-5 text-center text-lg text-[#6A7280] sm:text-xl">
            We&apos;re actively working on enhancing this feature to ensure it
            meets your expectations. Thank you for your patience.
          </div>
        </div>
      </div>
    </div>
  );
}
